module.exports = __webpack_public_path__ + "img/solana-logo.png";